import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@/environments/environment';
import { Params } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { handleError } from '../tools/handle-error.tools';
import { OssaCategoria } from '@/app/models/interface/ossa-categoria.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({
  providedIn: 'root',
})
export class OssaCategoriaService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'ossa-categoria/';

  findAll(params?: Params) {
    return this.http
      .get<CustomResponse<OssaCategoria[]>>(this.url, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          return data.result;
        }),
      );
  }
}
